import moment from "moment";
import { File } from "../../apiAgent";

export function dateFormatter(_date) {
    if (_date) {
        const dateObject = (typeof _date === 'string') ? new Date(_date) : _date;
        const year = dateObject.getFullYear();
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = monthNames[dateObject.getMonth()];
        const day = dateObject.getDate().toString().padStart(2, '0');
        return `${day}-${month}-${year}`;
    }
}

export function calculateDifference(toDate, fromDate) {
    // If fromDate is missing or invalid, we cannot compute a difference
    let b = moment(fromDate);
    if (!b.isValid()) {
        return 'N/A';
    }

    // If toDate is missing (e.g. current / till present), use current date
    let a = toDate ? moment(toDate) : moment();
    if (!a.isValid()) {
        // fallback to current date if provided toDate is invalid
        a = moment();
    }

    let years = a.diff(b, 'year');
    b.add(years, 'years');
    let months = a.diff(b, 'months');
    b.add(months, 'months');
    let days = a.diff(b, 'days');

    // Ensure numeric safety
    years = Number.isFinite(years) ? years : 0;
    months = Number.isFinite(months) ? months : 0;
    days = Number.isFinite(days) ? days : 0;

    let difference = years + ' years ' + months + ' months ' + days + ' days';
    return difference;
}
export function calculateDifferenceInDays(start_date) {
    if (this.candidate_history_info && this.candidate_history_info.length > 0) {
        // Sort history by end_date descending (treat null end_date as most recent)
        const sortedHistory = [...this.candidate_history_info].sort((a, b) => {
            const aEnd = a.end_date ? moment(a.end_date) : moment();
            const bEnd = b.end_date ? moment(b.end_date) : moment();
            return bEnd.diff(aEnd);
        });

        const latestEnd = sortedHistory[0].end_date ? moment(sortedHistory[0].end_date) : moment();

        const startDate = latestEnd;
        const endDate = start_date ? moment(start_date) : moment();

        if (!startDate.isValid() || !endDate.isValid()) return true;

        const daysDiff = endDate.diff(startDate, 'days');

        return daysDiff < 28;
    }

    // If no history exists, default to true
    return true;
}

export function fullName(candidate) {
    let fullName = `${candidate.forename} ${candidate.middle_name} ${candidate.surname}`;
    return candidate.full_name ?? fullName;
}
export function checkPolicyDeclaration(policyDeclarationInfo) {
    return policyDeclarationInfo.applicant_screening === true &&
        policyDeclarationInfo.criminal_background_check === true &&
        policyDeclarationInfo.declaration_by_applicant === true &&
        policyDeclarationInfo.financial_history === true &&
        policyDeclarationInfo.equality === true &&
        policyDeclarationInfo.working_time_directive === 'yes';
}

export async function saveBtnHandler(companyId = null) {
    let employment = this.candidateHistoryInfo.filter(x => x.type === 0);

    let education = this.candidateHistoryInfo.filter(x => x.type === 1);

    let selfEmployment = this.candidateHistoryInfo.filter(x => x.type === 2);

    let unEmployment = this.candidateHistoryInfo.filter(x => x.type === 3);

    this.registrationForm = {
        applicant: this.basicInfo,
        applicantPayroll: this.payrollInfo,
        applicantAddress: this.addressInfo,
        applicantTraining: this.trainingInfo,
        applicantEmployment: employment,
        applicantEducation: education,
        applicantSelfEmployment: selfEmployment,
        applicantUnemployment: unEmployment,
        applicantSiaDetail: this.siaInfo,
        applicantGdprDetail: this.gdprInfo,
        applicantPolicyDeclaration: this.policyDeclarationInfo,
        searchAction: this.searchAction ?? []
    };
    if (companyId) {
        this.registrationForm.company_id = companyId
    }

    // Handle pending files if they exist
    const hasPendingLicenses = this.basicInfo.licenses?.some(l => l.pending_license_document);
    if (this.basicInfo.pending_profile_pic || this.basicInfo.pending_passport || this.basicInfo.pending_driving_license || hasPendingLicenses) {
        this.preloader = true;
        try {
            if (this.basicInfo.pending_profile_pic) {
                let formData = new FormData();
                formData.append('email', this.basicInfo.email);
                formData.append('type', 'profile_pic');
                formData.append('files', this.basicInfo.pending_profile_pic);
                const response = await File.uploadDocument(formData);
                const uploadedFile = (response.data && response.data.data && response.data.data.length > 0) ? response.data.data[0] : null;
                if (uploadedFile && uploadedFile.file_path) {
                    this.$set(this.basicInfo, 'employee_picture_path', uploadedFile.file_path);
                    this.$set(this.basicInfo, 'employee_picture_id', uploadedFile.id);
                    this.$set(this.basicInfo, 'employee_picture_name', uploadedFile.file_name);
                }
                this.$set(this.basicInfo, 'pending_profile_pic', null);
                this.$set(this.basicInfo, 'employee_picture', null);
            }
            if (this.basicInfo.pending_passport) {
                let formData = new FormData();
                formData.append('email', this.basicInfo.email);
                formData.append('type', 'passport');
                formData.append('files', this.basicInfo.pending_passport);
                const response = await File.uploadDocument(formData);
                const uploadedFile = (response.data && response.data.data && response.data.data.length > 0) ? response.data.data[0] : null;
                if (uploadedFile && uploadedFile.file_path) {
                    this.$set(this.basicInfo, 'passport_path', uploadedFile.file_path);
                    this.$set(this.basicInfo, 'passport_id', uploadedFile.id);
                    this.$set(this.basicInfo, 'passport_name', uploadedFile.file_name);
                }
                this.$set(this.basicInfo, 'pending_passport', null);
                this.$set(this.basicInfo, 'passport', null);
            }
            if (this.basicInfo.pending_driving_license) {
                let formData = new FormData();
                formData.append('email', this.basicInfo.email);
                formData.append('type', 'driving_license');
                formData.append('files', this.basicInfo.pending_driving_license);
                const response = await File.uploadDocument(formData);
                const uploadedFile = (response.data && response.data.data && response.data.data.length > 0) ? response.data.data[0] : null;
                if (uploadedFile && uploadedFile.file_path) {
                    this.$set(this.basicInfo, 'driving_license_path', uploadedFile.file_path);
                    this.$set(this.basicInfo, 'driving_license_id', uploadedFile.id);
                    this.$set(this.basicInfo, 'driving_license_name', uploadedFile.file_name);
                }
                this.$set(this.basicInfo, 'pending_driving_license', null);
                this.$set(this.basicInfo, 'driving_license_document', null);
            }

            /*if (this.basicInfo.licenses && Array.isArray(this.basicInfo.licenses)) {
                for (let i = 0; i < this.basicInfo.licenses.length; i++) {
                    const license = this.basicInfo.licenses[i];
                    if (license.pending_license_document) {
                        let formData = new FormData();
                        formData.append('email', this.basicInfo.email);
                        formData.append('type', 'siaLicense');
                        formData.append('files', license.pending_license_document);
                        const response = await File.uploadDocument(formData);
                        const uploadedFile = (response.data && response.data.data && response.data.data.length > 0) ? response.data.data[0] : null;
                        if (uploadedFile && uploadedFile.file_path) {
                            this.$set(license, 'license_path', uploadedFile.file_path);
                            this.$set(license, 'license_id', uploadedFile.id);
                            this.$set(license, 'license_name', uploadedFile.file_name);
                        }
                        this.$set(license, 'pending_license_document', null);
                        this.$set(license, 'licensePreview', null);
                        this.$set(license, 'license_document', null);
                    }
                }
            }*/
        } catch (error) {
            this.$toastr.e("Failed to upload some files.");
        } finally {
            this.preloader = false;
        }
    }

    this.save(this.registrationForm);
}

export function validateAlphaNumericSixteenCharacter(input) {
    const regex = /^[a-zA-Z0-9]{16}$/;
    return regex.test(input);
}
export function validateAlphaNumeric(input,) {
    // Regular expression to match alphanumeric characters and spaces only
    const regex = /^[a-zA-Z0-9 ]*$/;

    // Test the input against the regex
    const isValid = regex.test(input);

    return isValid;
}
export function validateAlphabet(input) {
    // Allows letters, spaces, hyphens, and apostrophes
    const regex = /^[a-zA-Z\s'-]*$/;

    return regex.test(input);
}

export function validateNumeric(input, length = null) {
    // Regular expression to match numeric characters and spaces only
    const regex = /^[0-9\s]*$/;

    // Test the input against the regex
    let isValid = regex.test(input);

    // If the length is provided and not null, truncate the input to the specified length
    if (isValid && length !== null && !isNaN(length)) {
        input = input.substring(0, length);
    }

    // Return the truncated input and the validity status
    return { isValid, input };
}

export function validateEmail(input) {
    return String(input)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
}

export function mergeDateTime(dateStr, timeStr) {
    // Step 1: Parse the date string to create a Date object
    let date = new Date(dateStr);

    // Step 2: Parse the time string to extract hours and minutes
    const timeParts = timeStr.match(/(\d+):(\d+)\s*(AM|PM)/i);
    if (!timeParts) {
        throw new Error('Invalid time format');
    }

    let hours = parseInt(timeParts[1], 10);
    const minutes = parseInt(timeParts[2], 10);
    const period = timeParts[3].toUpperCase();

    // Convert 12 AM/PM to 24-hour format
    if (period === 'PM' && hours < 12) {
        hours += 12;
    } else if (period === 'AM' && hours === 12) {
        hours = 0;
    }

    // Step 3: Adjust the hours and minutes of the Date object
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
};
